<div class="technical-difficulties">
  <img src="/images/sadpath-open-search.svg" />
  <h4 class="h4-title-large">
    {{ 'TECHNICAL_DIFFICULTIES.TITLE' | translate }}
  </h4>
  <p class="body-large">
    {{ 'TECHNICAL_DIFFICULTIES.ASK_DESCRIPTION' | translate }}
  </p>
  @if (!hideButton()) {
    <button class="btn-secondary btn-small" data-fs-element="Error-404-Button-Open-Search" (click)="goOpenSearch()">
      {{ 'HOME.NO_PROJECTS.BUTTON' | translate }}
    </button>
  }
</div>
